// Auth state in localStorage. Token + user are persisted; api.ts reads them
// to attach Bearer headers and dispatch logout on 401.

export interface AuthedUser {
  id: number;
  tenant_id: number;
  email: string;
  role: 'owner' | 'operator';
  display_name: string;
}

const TOKEN_KEY = 'ngb.token';
const USER_KEY = 'ngb.user';

export function getToken(): string | null {
  return localStorage.getItem(TOKEN_KEY);
}

export function getUser(): AuthedUser | null {
  const raw = localStorage.getItem(USER_KEY);
  if (!raw) return null;
  try {
    return JSON.parse(raw) as AuthedUser;
  } catch {
    return null;
  }
}

export function setSession(token: string, user: AuthedUser) {
  localStorage.setItem(TOKEN_KEY, token);
  localStorage.setItem(USER_KEY, JSON.stringify(user));
}

export function clearSession() {
  localStorage.removeItem(TOKEN_KEY);
  localStorage.removeItem(USER_KEY);
}

export function isAuthed(): boolean {
  return Boolean(getToken() && getUser());
}
